import React from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

const TrustedBy = () => {
  const { ref, isVisible } = useScrollAnimation()

  const sectors = [
    { name: 'Construction', icon: 'fas fa-hard-hat' },
    { name: 'Healthcare', icon: 'fas fa-stethoscope' },
    { name: 'Technology', icon: 'fas fa-microchip' },
    { name: 'Finance', icon: 'fas fa-chart-line' },
    { name: 'Manufacturing', icon: 'fas fa-industry' },
    { name: 'Retail', icon: 'fas fa-store' },
    { name: 'Education', icon: 'fas fa-graduation-cap' },
    { name: 'Hospitality', icon: 'fas fa-concierge-bell' },
    { name: 'Engineering', icon: 'fas fa-gears' },
    { name: 'Agriculture', icon: 'fas fa-leaf' },
    { name: 'Transport', icon: 'fas fa-truck' },
    { name: 'Professional Services', icon: 'fas fa-briefcase' },
  ]

  return (
    <section id="trusted-by" className="trusted-by section-alt" ref={ref}>
      <div className="container">
        <div className="section-header">
          <div className={`section-tag ${isVisible ? 'animate-fadeInUp' : ''}`}>
            Sectors We Recruit Across
          </div>
          <h2 className={`${isVisible ? 'animate-fadeInUp' : ''}`}>
            Industries We <span className="gradient-text">Specialise In</span>
          </h2>
        </div>

        <div className={`sectors-ticker-wrap ${isVisible ? 'animate-fadeInUp' : ''}`}>
          <div className="sectors-ticker">
            <div className="sectors-track">
              {[...sectors, ...sectors].map((sector, index) => (
                <div key={index} className="sector-pill">
                  <i className={sector.icon}></i>
                  <span>{sector.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TrustedBy
